<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách cuộc gọi Call IO</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          v-if="dataCallIo.active"
          class="font-medium f12 btn btn-outline-secondary"
          v-b-modal.select-lead-dialog
          @click="call()"
        >
          Gọi điện thoại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group" @click="checkShowCallCenter()">
            <input type="hidden" class="form-control text-left" v-model="leadSelected" />
            <input
              type="text"
              class="form-control text-left"
              :value="leadSelected.merchantName ? `${leadSelected.merchantName}` : ''"
              placeholder="Merchant"
              v-b-modal.select-lead-dialog
            />
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(toNumber)="data">
                <strong>{{ data.item.toNumber }}</strong
                ><br />{{ data.item.contactName }}
              </template>
              <template #cell(initCallIoTime)="data">
                {{ data.item.initCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}
              </template>
              <template #cell(createCallIoTime)="data">
                {{ data.item.createCallIoTime | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(timing)="data">
                {{ getTiming(data.item.endCallIoTime, data.item.createCallIoTime) }}
              </template>
              <template #cell(direction)="data">
                {{ data.item.direction | formatDirection }}
              </template>
              <template #cell(crmResult)="data">
                <span v-if="data.item.crmResult"
                  >{{ data.item.crmResult | resultCall(resultStatusCalls) }}
                  <br />
                  {{ data.item.crmNote }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="detail(data.item.id)" class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <SelectLead @selectLead="onSelectLead" :listLead="true" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import { CallIoService } from '@/services/callio.service'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  // import cloneDeep from 'lodash/cloneDeep'
  import pad from 'lodash/pad'
  import SelectLead from '@/components/SelectLead.vue'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'toNumber', label: 'Liên hệ', thStyle: 'min-width: 170px' },
    { key: 'username', label: 'Nhân sự', thStyle: 'min-width: 170px' },
    { key: 'initCallIoTime', label: 'Thời gian khởi tạo', thStyle: 'min-width: 190px' },
    { key: 'createCallIoTime', label: 'Thời gian thực hiện', thStyle: 'min-width: 190px' },
    { key: 'timing', label: 'Thời gian gọi', thStyle: 'min-width: 170px' },
    { key: 'direction', label: 'Chiều gọi', thStyle: 'min-width: 170px' },
    { key: 'crmResult', label: 'Kết quả', thStyle: 'min-width: 170px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'list-call-io',
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataCallIo: JSON.parse(localStorage.getItem('callioConfig')),
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        leadSelected: {},
        resultStatusCalls: null,
        showCallCenter: false,
      }
    },
    components: { SelectLead },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    created() {
      // this.fetchData()
      this.fetchResultStatusCall()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.search
          const response = await CallIoService.getHistoryCallIo(params)
          if (response.code === 1000) {
            this.lists = response.data.list
            this.pagination.total = response.data.count
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.leadSelected = {}
        this.lists = []
      },
      async submitForm() {
        if (this.search.customerId) {
          this.search.page = 1
          this.fetchData()
        }
      },
      onSelectLead(lead) {
        this.leadSelected = lead
        this.search.customerId = lead.leadId
        if (this.showCallCenter === true) {
          if (lead.status === 'MERCHANT' || lead.status === 'POTENTIAL') {
            lead.merchantType = 'MERCHANT'
          } else lead.merchantType = 'LEAD'
          this.$store.commit('callio/SET_TMP_CURRENT_USER_CALL', {
            customerId: lead.leadId,
            customerName: lead.customerName,
            mobile: lead.mobile,
            email: lead.email,
            city: lead.city,
            district: lead.district,
            merchantType: lead.merchantType,
          })
          this.$store.commit('callio/SET_MODAL', true)
          this.$store.commit('callio/SET_MODAL_MINI', false)
        }
      },
      detail(id) {
        const routeData = this.$router.resolve({ path: `/call-io/${id}` })
        window.open(routeData.href, '_blank')
      },
      getTiming(endCallIoTime, createCallIoTime) {
        if (!endCallIoTime) return ''
        const end = moment(endCallIoTime)
        const start = moment(createCallIoTime)
        const duration = moment.duration(end.diff(start))
        return `${pad(duration.hours(), 2, '0')}:${pad(
          duration.minutes(),
          2,
          '0'
        )}:${pad(duration.seconds(), 2, '0')}`
      },
      async fetchResultStatusCall() {
        const response = await CallIoService.getResultStatusCall()
        this.resultStatusCalls = response.data
      },
      call() {
        this.showCallCenter = true
      },
      checkShowCallCenter() {
        this.showCallCenter = false
      },
    },
  }
</script>
<style scoped>
  .c-pointer {
    cursor: pointer;
  }
</style>
